module.exports = __webpack_public_path__ + "img/pr-3.3e4b9a1c.png";